// Sandboxed iframe render of the rendered email HTML (spec §4.3).
// srcDoc keeps the email's CSS scoped to the iframe and prevents any
// page-level styles from bleeding into the preview.
//
// Gap 2: when `channel === 'sms'`, render a simple chat-bubble preview of the
// plain-text body instead of the HTML iframe (an SMS has no HTML).

export default function PreviewPane({ html, loading, channel = 'email', smsBody = '', smsTo = '' }) {
  if (loading) {
    return (
      <div className="flex h-full min-h-[200px] items-center justify-center text-xs text-text-muted">
        Rendering preview…
      </div>
    );
  }

  if (channel === 'sms') {
    return (
      <div className="flex h-full min-h-[200px] flex-col gap-2 rounded-card bg-bg/60 p-3">
        {smsTo ? (
          <span className="text-[10px] uppercase tracking-wide text-text-dim">To {smsTo}</span>
        ) : null}
        {smsBody.trim() ? (
          <div className="flex justify-end">
            <div className="max-w-[80%] whitespace-pre-wrap break-words rounded-2xl rounded-br-sm bg-accent px-3 py-2 text-sm text-white">
              {smsBody}
            </div>
          </div>
        ) : (
          <div className="flex h-full items-center justify-center text-xs text-text-dim">
            Type a message to preview the text.
          </div>
        )}
      </div>
    );
  }

  if (!html) {
    return (
      <div className="flex h-full min-h-[200px] items-center justify-center text-xs text-text-dim">
        Pick a template to preview.
      </div>
    );
  }
  return (
    <iframe
      title="Email preview"
      srcDoc={html}
      sandbox=""
      className="h-full min-h-[300px] w-full rounded-card border border-border bg-white"
    />
  );
}
